
const state = {
  personaltoken: '/common/auth/personaltoken/',
  logout: '/common/auth/logout',
  echo: '/common/echo',
  echocount: '/common/echo/count',
  sseserver: '/common/sseserver',
  homenetNoti: '/homenet/notice',
  homenetNotiTitle: '/homenet/notice/title',
  homenetNotiMessage: '/homenet/notice/message',
  homenetNotiLatest: '/homenet/notice/latest',
  homenetuser: '/common/users',
  homenetDevice: '/homenet/device',
  homenetDeviceStatus: '/homenet/device/status',
  homenetDeviceControl: '/homenet/device/control',
  homenetCallback: '/homenet/callback',
  homenetCallbackNoti: '/homenet/callback/noti',
  homenetParking: '/homenet/parking',
  homenetParkingLocation: '/homenet/parking/location',
  homenetParkingInfo: '/homenet/parking/info',
  homenetParkingHistory: '/homenet/parking/innouthistory',
  homenetParkingAvailable: '/homenet/parking/available',
  homenetParkinglot: '/homenet/parking/parkinglot',
  homenetParkingCar: '/homenet/parking/car',
  homenetParkingCarPark: '/homenet/parking/park',
  nexia: '/nexia/external/smart_things',
  nexiaWebhook: '/nexia/webhook',
  homenetParcel: '/homenet/parcel',
  homenetVisitor: '/homenet/visitor',
  homenetVisitorVehicle: '/homenet/visitorvehicle',
  homenetVote: '/homenet/vote',
  homenetContact: '/homenet/contact',
  homenetBill: '/homenet/bill',
  homenetEms: '/homenet/ems',
  homenetPushNoti: '/homenet/notification',
  homenetServiceInfo: '/homenet/serviceInfo',
  homenetElv: '/homenet/elevator',
  homenetElvList: '/homenet/elevator/list',
  homenetElvCall: '/homenet/elevator/call',
  homenetElvSse: '/homenet/elevator/sse',
  homenetElvUp: '/homenet/elevator/up',
  homenetElvDown: '/homenet/elevator/down',
  homenetCctv: '/homenet/cctv',
  homenetComplexDetail: '/homenet/complex/detail',
  homenetUserInfo: '/homenet/userinfo',
  homenetNotificationRequest: '/homenet/notification/request',
  homenetEvcharge: '/homenet/evcharge',
  homenetLegalInfo: '/homenet/legalInformation',
  homenetBrandInfo: '/homenet/brandInfo',
  homenetLinkedService: '/homenet/linkedService',
  residentPartner: '/common/partner',
  residentComplex: '/common/complex',
  resident: '/common/residents',
  residentUser: '/common/user',
  stdevice: '/stdevice/device',
  connectorInfo: '/connector/state'
}

export default {
  state
}



// WEBPACK FOOTER //
// ./client/store/modules/api.js